import { c as _c } from "react-compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
import { useSelectionDispatch } from '../../redux/reduxHooks';
import { clearSelection, unselectObjectsNoLongerInTable } from '../../selection/redux/selectionSlice';
import { useResetVisibleIndexes } from '../../virtualization/VirtualizationContext';
const areRowIdsEqual = (currentRows, prevRows) => prevRows && prevRows.length === currentRows.length && prevRows.every((rowId, index) => currentRows[index] === rowId);
export const useResetTableState = t0 => {
  const $ = _c(8);
  const {
    rowIds,
    tableContainerRef,
    resetObserver,
    tableResetKey
  } = t0;
  const resetVisibleIndexes = useResetVisibleIndexes();
  const prevRowIdsRef = useRef(null);
  const prevScrollResetKeyRef = useRef(tableResetKey);
  const dispatch = useSelectionDispatch();
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== resetObserver || $[2] !== resetVisibleIndexes || $[3] !== rowIds || $[4] !== tableContainerRef || $[5] !== tableResetKey) {
    t1 = () => {
      const rowsChanged = !areRowIdsEqual(rowIds, prevRowIdsRef.current);
      const hasKey = tableResetKey !== undefined;
      const keyChanged = hasKey && tableResetKey !== prevScrollResetKeyRef.current;
      if (!rowsChanged && !keyChanged) {
        return;
      }
      prevRowIdsRef.current = rowIds;
      prevScrollResetKeyRef.current = tableResetKey;
      if (!hasKey || keyChanged) {
        dispatch(clearSelection());
        resetVisibleIndexes();
        if (tableContainerRef.current) {
          tableContainerRef.current.scrollTop = 0;
        }
      } else {
        if (rowsChanged) {
          dispatch(unselectObjectsNoLongerInTable(rowIds));
        }
      }
      resetObserver();
    };
    t2 = [dispatch, resetObserver, rowIds, tableResetKey, tableContainerRef, resetVisibleIndexes];
    $[0] = dispatch;
    $[1] = resetObserver;
    $[2] = resetVisibleIndexes;
    $[3] = rowIds;
    $[4] = tableContainerRef;
    $[5] = tableResetKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useLayoutEffect(t1, t2);
};